/* Popinker shared UI script
   - Language toggle (E/中) via localStorage
   - Case study cards rendering (Home + Case Studies page)
   - Optional view switching for pages that include .page-view blocks
*/

(function () {
  const STORAGE_KEY = "popinker_lang";

  const caseStudiesData = [
    {
      id: "tiger",
      titleEn: "Forest Guardian Tiger",
      titleZh: "森林守护神虎",
      client: "Self-Initiated",
      goalEn:
        "Develop an imposing, highly-detailed collectible figure demonstrating hard-surface and organic sculpting.",
      goalZh:
        "开发一款极具气势与高细节的收藏级实体模型，展示有机生物与硬表面结合的雕刻技术。",
      conceptEn:
        "A mythic tiger spirit adorned with ancient armor. The sketch focused on the aggressive stance and the cultural motifs on the armor plating.",
      conceptZh:
        "身披古老战甲的神话灵虎。草图着重表现其极具攻击性的姿态以及战甲上的传统文化图腾。",
      sculptEn:
        "Digital sculpting done in ZBrush. We emphasized the fur texture flowing naturally into the rigid metallic armor elements. Proportions were exaggerated slightly for a dramatic silhouette.",
      sculptZh:
        "使用 ZBrush 进行高精度数字雕刻。我们强调毛发纹理与坚硬金属战甲之间的自然过渡。为增强视觉张力，对局部比例进行了夸张处理。",
      productionEn:
        "The prototype was SLA 3D printed in high-toughness resin. The figure stands at 8 inches tall. Complex undercuts required a 12-part separation strategy for seamless mold making.",
      productionZh:
        "实物原型采用高韧性树脂进行 SLA 3D 打印，全高 8 英寸。由于存在复杂的倒角，我们制定了 12 个部件的拆分方案，以确保后续硅胶翻模的完美无瑕。",
      thumbImg:
        "https://cdn.shopify.com/s/files/1/0874/6860/5753/files/unnamed.jpg?v=1773027549",
      conceptImg:
        "https://cdn.shopify.com/s/files/1/0874/6860/5753/files/pluff9.png?v=1770890797",
      sculptImg:
        "https://cdn.shopify.com/s/files/1/0874/6860/5753/files/2506_35.png?v=1770890973",
      prototypeImg:
        "https://cdn.shopify.com/s/files/1/0874/6860/5753/files/IMG_1674.jpg?v=1717841112",
    },
    {
      id: "rabbit",
      titleEn: "Moon Rabbit",
      titleZh: "月宫玉兔",
      client: "Indie Designer Project",
      goalEn:
        "Create a cute but stylized art toy prototype blending traditional folklore with modern aesthetics.",
      goalZh: "打造一款将传统神话与现代潮玩审美相结合的可爱风潮玩原型。",
      conceptEn:
        "The concept revolves around a rabbit holding a celestial mortar. Soft, rounded shapes were chosen to give a soothing, tactile feel.",
      conceptZh:
        "概念围绕着一只怀抱捣药杵的玉兔展开。选用柔软圆润的线条设计，赋予其治愈且易于触摸的视觉感受。",
      sculptEn:
        "Sculpted with a focus on smooth, minimalist surfaces. The challenge was keeping the face expressive while minimizing complex geometry to fit the 'blind box' toy style.",
      sculptZh:
        "雕刻重点在于光滑极简的表面处理。难点在于如何在减少复杂几何体结构（以适配盲盒风格）的同时，保持面部的生动表现力。",
      productionEn:
        "Sanded to a mirror finish before applying a matte pastel colorway. The piece serves as a master prototype for potential vinyl production.",
      productionZh:
        "在喷涂马卡龙哑光漆面之前，原型经过了镜面级的极致打磨。该模型目前作为未来可能进行搪胶量产的母版原型。",
      thumbImg:
        "https://cdn.shopify.com/s/files/1/0874/6860/5753/files/IMG_1658.png?v=1717742787",
      conceptImg:
        "https://cdn.shopify.com/s/files/1/0874/6860/5753/files/IMG_1666_aaaac3ed-ffdb-4fe5-b858-90bf906311fb.jpg?v=1717845990",
      sculptImg:
        "https://cdn.shopify.com/s/files/1/0874/6860/5753/files/IMG_1658.png?v=1717742787",
      prototypeImg:
        "https://cdn.shopify.com/s/files/1/0874/6860/5753/files/IMG_1658.png?v=1717742787",
    },
    {
      id: "teacat",
      titleEn: "Lucky Tea Cat",
      titleZh: "招财茶猫",
      client: "Self-Initiated",
      goalEn:
        "Design a desktop collectible blending cafe culture with the traditional maneki-neko.",
      goalZh: "设计一款融合咖啡馆文化与传统招财猫元素的桌面级潮玩摆件。",
      conceptEn:
        "A chubby cat relaxing inside an oversized teacup. Sketching explored different facial expressions and cup decorations.",
      conceptZh:
        "一只胖乎乎的猫咪在巨大的茶杯里休憩。草图阶段探索了各种面部表情以及杯身的印花装饰。",
      sculptEn:
        "The 3D modeling required careful attention to the fit between the cat and the cup, ensuring they could be cast separately but assemble perfectly.",
      sculptZh:
        "3D建模需要特别关注猫咪与茶杯之间的契合度公差，确保它们可以分别独立翻模，但拼装时严丝合缝。",
      productionEn:
        "Cast in solid PU resin for weight and premium feel. Painted with glossy ceramic-like finishes for the cup and a flocked texture for the cat.",
      productionZh:
        "采用高密度 PU 树脂翻模，以增加压手感与高级感。茶杯部分采用陶瓷质感的高光漆面，猫咪则尝试了植绒质感。",
      thumbImg:
        "https://cdn.shopify.com/s/files/1/0874/6860/5753/files/pluff9.png?v=1770890797",
      conceptImg:
        "https://cdn.shopify.com/s/files/1/0874/6860/5753/files/IMG_1668.jpg?v=1717846310",
      sculptImg:
        "https://cdn.shopify.com/s/files/1/0874/6860/5753/files/IMG_1674.jpg?v=1717841112",
      prototypeImg:
        "https://cdn.shopify.com/s/files/1/0874/6860/5753/files/2506_35.png?v=1770890973",
    },
    {
      id: "panda",
      titleEn: "Mountain Panda",
      titleZh: "高山隐士熊猫",
      client: "Client Commission",
      goalEn: "An art toy capturing Zen philosophy.",
      goalZh: "一款捕捉禅意哲学的艺术玩具。",
      conceptEn: "Panda meditating on a mountain peak.",
      conceptZh: "在山顶打坐冥想的熊猫。",
      sculptEn:
        "Focus on the mountain's rocky texture versus the panda's soft curves.",
      sculptZh: "重点处理山峰的岩石肌理与熊猫柔软曲线之间的对比。",
      productionEn:
        "Standard 3D print and resin cast. Painted with stone-like effects.",
      productionZh: "标准的3D打印与树脂翻模。采用仿石材特效涂装。",
      thumbImg:
        "https://cdn.shopify.com/s/files/1/0874/6860/5753/files/IMG_1674.jpg?v=1717841112",
      conceptImg:
        "https://cdn.shopify.com/s/files/1/0874/6860/5753/files/IMG_1674.jpg?v=1717841112",
      sculptImg:
        "https://cdn.shopify.com/s/files/1/0874/6860/5753/files/IMG_1674.jpg?v=1717841112",
      prototypeImg:
        "https://cdn.shopify.com/s/files/1/0874/6860/5753/files/IMG_1674.jpg?v=1717841112",
    },
    {
      id: "crane",
      titleEn: "Little Crane Monk",
      titleZh: "仙鹤小僧",
      client: "Self-Initiated",
      goalEn: "Character design showcasing drapery and fabric flow.",
      goalZh: "展示衣褶与布料垂坠感动态的角色设计。",
      conceptEn: "A young monk with crane motifs on his oversized robes.",
      conceptZh: "穿着带有仙鹤图腾的宽大僧袍的小和尚。",
      sculptEn:
        "Extensive cloth simulation and manual sculpting for dynamic wind effects.",
      sculptZh: "进行了大量的布料物理模拟及手工雕刻，以表现随风飘动的动态美感。",
      productionEn:
        "Printed in ABS-like resin to prevent thin robe edges from snapping.",
      productionZh: "采用类 ABS 韧性树脂打印，以防止轻薄的衣摆边缘断裂。",
      thumbImg:
        "https://cdn.shopify.com/s/files/1/0874/6860/5753/files/IMG_1666_aaaac3ed-ffdb-4fe5-b858-90bf906311fb.jpg?v=1717845990",
      conceptImg:
        "https://cdn.shopify.com/s/files/1/0874/6860/5753/files/IMG_1666_aaaac3ed-ffdb-4fe5-b858-90bf906311fb.jpg?v=1717845990",
      sculptImg:
        "https://cdn.shopify.com/s/files/1/0874/6860/5753/files/IMG_1666_aaaac3ed-ffdb-4fe5-b858-90bf906311fb.jpg?v=1717845990",
      prototypeImg:
        "https://cdn.shopify.com/s/files/1/0874/6860/5753/files/IMG_1666_aaaac3ed-ffdb-4fe5-b858-90bf906311fb.jpg?v=1717845990",
    },
    {
      id: "dog",
      titleEn: "Cloud Dog Spirit",
      titleZh: "云端神犬",
      client: "Indie Studio",
      goalEn: "A fluffy, cloud-like creature for a blind box series.",
      goalZh: "为盲盒系列打造的毛茸茸、云朵般的神秘生物。",
      conceptEn: "Dog composed entirely of cloud shapes, very bubbly and light.",
      conceptZh: "完全由云朵形状构成的神犬，极具充气感与轻盈感。",
      sculptEn:
        "Merging individual spheres into a cohesive, recognizable dog anatomy.",
      sculptZh:
        "将独立的球体融合进一个连贯且具有辨识度的犬类解剖结构中。",
      productionEn:
        "Testing translucent resins to give a soft, glowing cloud effect.",
      productionZh: "正在测试半透明树脂材料，以呈现出柔和发光的云朵特效。",
      thumbImg:
        "https://cdn.shopify.com/s/files/1/0874/6860/5753/files/2506_35.png?v=1770890973",
      conceptImg:
        "https://cdn.shopify.com/s/files/1/0874/6860/5753/files/2506_35.png?v=1770890973",
      sculptImg:
        "https://cdn.shopify.com/s/files/1/0874/6860/5753/files/2506_35.png?v=1770890973",
      prototypeImg:
        "https://cdn.shopify.com/s/files/1/0874/6860/5753/files/2506_35.png?v=1770890973",
    },
  ];

  function safeText(el, text) {
    if (!el) return;
    el.textContent = text == null ? "" : String(text);
  }

  function getLang() {
    const stored = window.localStorage.getItem(STORAGE_KEY);
    return stored === "zh" ? "zh" : "en";
  }

  function setLang(lang) {
    const l = lang === "zh" ? "zh" : "en";
    window.localStorage.setItem(STORAGE_KEY, l);
    applyLanguage(l);
    syncLangToggleUI(l);
  }

  function applyLanguage(lang) {
    document.querySelectorAll(".lang-text, .nav-text, .lang-text-dynamic").forEach((el) => {
      const key = `data-${lang}`;
      const next = el.getAttribute(key);
      if (next != null) safeText(el, next);
    });
  }

  function syncLangToggleUI(lang) {
    const toggles = document.querySelectorAll("#popinker-nav-lang [data-lang]");
    toggles.forEach((btn) => {
      const active = btn.getAttribute("data-lang") === lang;
      btn.classList.toggle("bg-black", active);
      btn.classList.toggle("text-white", active);
      btn.classList.toggle("shadow-md", active);
      btn.classList.toggle("text-gray-400", !active);
    });
  }

  function initLangToggle() {
    const container = document.getElementById("popinker-nav-lang");
    if (!container) return;
    container.addEventListener("click", (e) => {
      const btn = e.target.closest("[data-lang]");
      if (!btn) return;
      setLang(btn.getAttribute("data-lang"));
    });
    const lang = getLang();
    syncLangToggleUI(lang);
    applyLanguage(lang);
  }

  function navigateTo(viewId) {
    const target = document.getElementById(`view-${viewId}`);
    if (!target) return;
    document.querySelectorAll(".page-view").forEach((el) => el.classList.remove("active"));
    target.classList.add("active");
    window.scrollTo({ top: 0, behavior: "smooth" });
  }

  function openCaseStudy(id) {
    const data = caseStudiesData.find((c) => c.id === id);
    if (!data) return;
    const lang = getLang();

    const heroImg = document.getElementById("cs-hero-img");
    if (heroImg) heroImg.src = data.thumbImg;

    const title = document.getElementById("cs-title");
    if (title) {
      title.setAttribute("data-en", data.titleEn);
      title.setAttribute("data-zh", data.titleZh);
      title.classList.add("lang-text-dynamic");
      safeText(title, lang === "zh" ? data.titleZh : data.titleEn);
    }

    const goal = document.getElementById("cs-goal");
    if (goal) {
      goal.setAttribute("data-en", data.goalEn);
      goal.setAttribute("data-zh", data.goalZh);
      goal.classList.add("lang-text-dynamic");
      safeText(goal, lang === "zh" ? data.goalZh : data.goalEn);
    }

    safeText(document.getElementById("cs-client"), data.client);
    safeText(document.getElementById("cs-tag"), "Art Toy Prototype");

    const imgConcept = document.getElementById("cs-img-concept");
    if (imgConcept) imgConcept.src = data.conceptImg;
    const imgSculpt = document.getElementById("cs-img-sculpt");
    if (imgSculpt) imgSculpt.src = data.sculptImg;
    const imgProto = document.getElementById("cs-img-prototype");
    if (imgProto) imgProto.src = data.prototypeImg;

    const conceptText = document.getElementById("cs-concept-text");
    if (conceptText) {
      conceptText.setAttribute("data-en", data.conceptEn);
      conceptText.setAttribute("data-zh", data.conceptZh);
      conceptText.classList.add("lang-text-dynamic");
      safeText(conceptText, lang === "zh" ? data.conceptZh : data.conceptEn);
    }

    const sculptText = document.getElementById("cs-sculpt-text");
    if (sculptText) {
      sculptText.setAttribute("data-en", data.sculptEn);
      sculptText.setAttribute("data-zh", data.sculptZh);
      sculptText.classList.add("lang-text-dynamic");
      safeText(sculptText, lang === "zh" ? data.sculptZh : data.sculptEn);
    }

    const prodText = document.getElementById("cs-production-text");
    if (prodText) {
      prodText.setAttribute("data-en", data.productionEn);
      prodText.setAttribute("data-zh", data.productionZh);
      prodText.classList.add("lang-text-dynamic");
      safeText(prodText, lang === "zh" ? data.productionZh : data.productionEn);
    }

    applyLanguage(lang);
    navigateTo("case-study");
    if (window.lucide && typeof window.lucide.createIcons === "function") {
      window.lucide.createIcons();
    }
  }

  var caseStudyPageUrls = {
    tiger: "/pages/case-study-forest-guardian",
    rabbit: "/pages/case-study-moon-rabbit",
    teacat: "/pages/case-study-lucky-teacat",
  };

  function renderGrids() {
    const homeGrid = document.getElementById("featured-cases-grid");
    const portGrid = document.getElementById("portfolio-grid");
    if (!homeGrid && !portGrid) return;

    const lang = getLang();
    var caseStudiesListUrl = "/pages/case-studies";
    try {
      var link = document.querySelector('a[href*="case-studies"]');
      if (link && link.href) caseStudiesListUrl = link.getAttribute("href") || caseStudiesListUrl;
    } catch (e) {}

    var cardHTML = function (caseData, asLink) {
      var url = asLink ? (caseStudyPageUrls[caseData.id] || caseStudiesListUrl) : null;
      var inner = `
        <div class="rounded-[2rem] overflow-hidden bg-white shadow-xl group flex flex-col h-full border border-gray-100 hover:border-yellow-400 transition-colors ${asLink ? "" : "cursor-pointer"}">
          <div class="h-64 overflow-hidden relative">
            <img src="${caseData.thumbImg}" alt="" class="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700">
          </div>
          <div class="p-6 flex-grow flex flex-col justify-between">
            <div>
              <h3 class="text-xl font-bold text-slate-900 mb-2 lang-text-dynamic" data-en="${caseData.titleEn}" data-zh="${caseData.titleZh}">
                ${lang === "zh" ? caseData.titleZh : caseData.titleEn}
              </h3>
              <p class="text-sm text-slate-500 line-clamp-2 lang-text-dynamic" data-en="${caseData.conceptEn}" data-zh="${caseData.conceptZh}">
                ${lang === "zh" ? caseData.conceptZh : caseData.conceptEn}
              </p>
            </div>
            <div class="mt-6 flex items-center text-yellow-500 font-bold text-sm">
              <span class="lang-text" data-en="View Project" data-zh="查看项目详情">${lang === "zh" ? "查看项目详情" : "View Project"}</span>
              <i data-lucide="arrow-right" class="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform"></i>
            </div>
          </div>
        </div>
      `;
      if (asLink) return '<a href="' + url + '" class="block no-underline text-inherit h-full">' + inner + "</a>";
      return '<div data-case-id="' + caseData.id + '">' + inner + "</div>";
    };

    if (homeGrid) {
      homeGrid.innerHTML = "";
      caseStudiesData.slice(0, 3).forEach(function (c) {
        homeGrid.innerHTML += cardHTML(c, true);
      });
    }

    if (portGrid) {
      portGrid.innerHTML = "";
      caseStudiesData.forEach(function (c) {
        portGrid.innerHTML += cardHTML(c, false);
      });
    }

    var bind = function (root) {
      if (!root) return;
      root.querySelectorAll("[data-case-id]").forEach(function (el) {
        el.addEventListener("click", function () {
          openCaseStudy(el.getAttribute("data-case-id"));
        });
      });
    };
    bind(portGrid);

    if (window.lucide && typeof window.lucide.createIcons === "function") {
      window.lucide.createIcons();
    }
  }

  function initHeroImage() {
    const hero = document.querySelector(".img-hero-main");
    if (hero && !hero.getAttribute("src")) hero.setAttribute("src", caseStudiesData[0].thumbImg);
  }

  function init() {
    // Expose small API for templates that want it
    window.Popinker = window.Popinker || {};
    window.Popinker.setLang = setLang;
    window.Popinker.getLang = getLang;
    window.Popinker.navigateTo = navigateTo;
    window.Popinker.openCaseStudy = openCaseStudy;

    if (window.lucide && typeof window.lucide.createIcons === "function") {
      window.lucide.createIcons();
    }
    initLangToggle();
    initHeroImage();
    renderGrids();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();

